import React from "react";
import "./solution.css";
// import pointerIcon from "../../assets/SolutionSection/pointer-icon.svg";
import solutionsImage from "../../assets/SolutionSection/solution-imgage.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
export default function Solution() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const solutionPoints = [
    {
      heading: "Risk Assessment & Threat Detection",
      paragraph:
        "Identify vulnerabilities like data poisoning, model exfiltration, and prompt injection.",
    },
    {
      heading: "End-to-End Security Controls",
      paragraph:
        "Safeguard AI applications with multi-layered security across data, models, and infrastructure.",
    },
    {
      heading: "Real-Time AI System Monitoring",
      paragraph:
        "Continuously track AI behavior, detect anomalies, and mitigate threats in real time.",
    },
    {
      heading: "Automated Compliance Management",
      paragraph:
        "Ensure AI adherence to industry security standards and regulatory frameworks.",
    },
  ];

  return (
    <section
      className={`solution-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="two"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Solution</span>
          </div>
          <div className="heading-description">
            <h2>
              Building Secure and Resilient AI: AI Risk Mitigation, Monitoring,
              and Compliance
            </h2>
            <p>
              Unlock cutting-edge security solutions that protect AI systems
              with real-time threat detection, risk mitigation, and compliance
              management, ensuring AI integrity and resilience.
            </p>
          </div>
        </div>
        <div className="solution-section-content">
          <div className="solution-cards-wrapper row">
            <div className="col-sm-5 col-md-5 col-lg-5">
              <img
                src={solutionsImage}
                alt="solution-img"
                className="solutions-img"
              />
            </div>
            <div className="col-sm-7 col-md-7 col-lg-6">
              <div className="solution-points-wrapper row">
                {solutionPoints.map((point, index) => (
                  <div className="col-12 col-sm-6">
                    <div className="solution-point" key={index}>
                      <h3>{point.heading}</h3>
                      <p>{point.paragraph}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
